module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('list', {
    attrs: {
      "listTitle": _vm.$t('amazon.accounts.label'),
      "listLogo": _vm.definitionModule.logo,
      "filterTitle": "Filtros",
      "typesListAvailable": ['displayList'],
      "loading": _vm.loadingSearch || _vm.loadingAddAccount,
      "total": _vm.amazonAccountsTotal,
      "sortFields": _vm.sortFields,
      "sortDefault": {
        field: _vm.sortFields[0],
        order: 'asc'
      }
    },
    on: {
      "change": _vm.onChange
    }
  }, [_c('div', {
    staticClass: "btnGroup",
    attrs: {
      "slot": "header-actions"
    },
    slot: "header-actions"
  }, [_c('button', {
    staticClass: "hint hint--left btn btn--info",
    attrs: {
      "slot": "header-actions",
      "data-label": "Adicionar conta"
    },
    on: {
      "click": function($event) {
        return _vm.amazonAuthenticate()
      }
    },
    slot: "header-actions"
  }, [_c('i', {
    staticClass: "icon-plus"
  })])]), _vm._v(" "), _c('template', {
    slot: "filters"
  }, [_c('form-group', {
    attrs: {
      "label": "Nome"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.options.shopName),
      expression: "options.shopName"
    }],
    staticClass: "form-input",
    domProps: {
      "value": (_vm.options.shopName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.options, "shopName", $event.target.value)
      }
    }
  })])], 1), _vm._v(" "), _vm._l((_vm.amazonAccounts), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "l-col-4@md"
    }, [_c('account', {
      attrs: {
        "account": item
      }
    })], 1)
  }), _vm._v(" "), (!_vm.amazonAccounts.length) ? _c('div', {
    staticClass: "l-col u-textCenter"
  }, [_c('panel', [_vm._v("\n        Nenhuma contra foi encontrado.\n      ")])], 1) : _vm._e()], 2), _vm._v(" "), _c('modal-account-confirmation', {
    attrs: {
      "account": _vm.account
    },
    on: {
      "confirm": _vm.accountConfirm
    },
    model: {
      value: (_vm.modalConfirmFlag),
      callback: function($$v) {
        _vm.modalConfirmFlag = $$v
      },
      expression: "modalConfirmFlag"
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-29c50184","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/MarketplaceAccount/Amazon/List.vue
// module id = 3006
// module chunks = 0